import api from "./api";

export const invoiceApi = {
  list: (params = "") => api.get(`/invoices${params}`),
  getById: (id) => api.get(`/invoices/${id}`),
  getPrintData: (id) => api.get(`/invoices/${id}/print-data`),
  create: (data) => api.post("/invoices", data),
  update: (id, data) => api.put(`/invoices/${id}`, data),
  remove: (id) => api.delete(`/invoices/${id}`),
  getNextNumber: () => api.get("/invoices/next-number"),
};